import React, { useEffect, useState } from 'react'
import { Col, Row } from 'react-bootstrap'
import { Link, useLocation, matchPath, useNavigate, useSearchParams } from 'react-router-dom'
import Slider from 'react-slick'
import { useAuth } from '../../context/ContextData'

const MobHeader = () => {
    const navigate = useNavigate();
    const { cart, setCart, wished, setWished, removeCart, removeWished, basicInfo, demo, setDemo, setDealerId } = useAuth()
    const { pathname } = useLocation();

    const [searchParams] = useSearchParams();

    const url = window.location.pathname.split("/")
    const product = url[1]

    const getDealerId = searchParams.get('dealerId') || localStorage.getItem("dealerId")
    const sid = searchParams.get('sid')

    useEffect((async) => {
        if (!localStorage.getItem("dealerId") && getDealerId !== null) {
            localStorage.setItem("dealerId", getDealerId)
            setDealerId(getDealerId)
        }
    }, [getDealerId, sid, setDealerId])

    const productdetails = matchPath("/productdetails/:any/:id", pathname);
    const orderdetails = matchPath("/checkout/cart", pathname);
    const myorders = matchPath("/order", pathname);
    const about = matchPath("/about", pathname);
    const terms = matchPath("/terms", pathname);
    const privacy = matchPath("/privacy", pathname);
    const categories = matchPath("/categories", pathname);
    const search = matchPath("/search", pathname);
    const careersjobId = matchPath("/careers/:any/:any/", pathname);

    const [parms, setParms] = useState("")
    const [aboutparms, setAbout] = useState("")
    const [jobId, setJobId] = useState("")
    const [bannerData, setBanner] = useState([])

    // const [dealerId, setDealerId1] = useState("")

    useEffect(() => {
        if (productdetails !== null) {
            setParms(productdetails.pathname)
        }
        if (orderdetails !== null) {
            setParms(orderdetails.pathname)
        }
        if (myorders !== null) {
            setParms(myorders.pathname)
        }
        if (terms !== null) {
            setParms(terms.pathname)
        }
        if (privacy !== null) {
            setParms(privacy.pathname)
        }
        if (categories !== null) {
            setParms(categories.pathname)
        }
        if (search !== null) {
            setParms(search.pathname)
        }
        if (about !== null) {
            setAbout(about.pathname)
        }
        if (careersjobId !== null) {
            setJobId(careersjobId.pathname)
        }
    }, [productdetails, orderdetails, myorders, about, terms, privacy, categories, search, careersjobId]);

    const homeBanner = [
        "https://res.cloudinary.com/wallicon21/image/upload/v1642059242/react/home/headerBanner/wallpaper-home-banner_rsrxxo.jpg",
        "https://res.cloudinary.com/wallicon21/image/upload/v1642059242/react/home/headerBanner/pvc-main-banner_fhefgi.jpg",
        "https://res.cloudinary.com/wallicon21/image/upload/v1642059242/react/home/headerBanner/flooring-main-banner_hb3bqr.jpg",
        "https://res.cloudinary.com/wallicon21/image/upload/v1642059242/react/home/headerBanner/artificial-grass-main-banner_oskvqf.jpg",
        "https://res.cloudinary.com/wallicon21/image/upload/v1642059243/react/home/headerBanner/vertical-garden_main_banner_m5xeys.jpg",
        "https://res.cloudinary.com/wallicon21/image/upload/v1642059242/react/home/headerBanner/ceiling-main-banner_mgf0re.jpg",
    ]

    useEffect(() => {
        if (pathname !== '/') {
            var myHeaders = new Headers();
            myHeaders.append("wu-platform", process.env.REACT_APP_USER_SECRET);
            myHeaders.append("Content-Type", "application/json");

            var raw = JSON.stringify({
                product_name: product.toUpperCase().replace(/-/g, ' '),
                sid: !sid ? "" : sid,
                // dealerId: dealerId
            });

            var requestOptions = {
                method: 'POST',
                headers: myHeaders,
                body: raw,
                redirect: 'follow'
            };

            fetch(process.env.REACT_APP_URL + "customer/getBanner", requestOptions)
                .then(response => response.json())
                .then(result => {
                    if (result.status === "success") {
                        setBanner(result.data);
                    }
                })
                .catch(error => console.log('error', error));

        }

    }, [pathname, product, sid])

    // set dealer id
    // useEffect(() => {
    //     if (dealerId && dealerId.length === 10) {
    //         var myHeaders = new Headers();
    //         myHeaders.append("wu-platform", process.env.REACT_APP_USER_SECRET);
    //         myHeaders.append("Content-Type", "application/json");

    //         var raw = JSON.stringify({
    //             "dealerId": dealerId
    //         });

    //         var requestOptions = {
    //             method: 'POST',
    //             headers: myHeaders,
    //             body: raw,
    //             redirect: 'follow'
    //         };

    //         fetch(process.env.REACT_APP_URL + "customer/dealerConnect", requestOptions)
    //             .then(response => response.json())
    //             .then(result => {
    //                 if (result.status === "success") {
    //                     localStorage.setItem("dealerId", result.dealer.dealerId);
    //                     localStorage.setItem("storeName", result.dealer.storeName);
    //                     // navigate("/");
    //                     setDealerId(result.dealer.dealerId);
    //                 }
    //             })
    //             .catch(error => console.log('error', error));
    //     }
    // }, [dealerId, navigate, setDealerId]);

    // ---------------------------Cart Items------------------------
    useEffect(() => {
        const localCart = JSON.parse(localStorage.getItem("cart"))
        if (localCart && cart.length === 0) {
            if (removeCart === 0) {
                localStorage.removeItem("cart")
            } else {
                setCart(localCart)
            }
        }
    }, [cart, setCart, removeCart,])

    const lDealerId = localStorage.getItem("dealerId")

    useEffect(() => {
        if (pathname === "/demo") {
            sessionStorage.setItem("demo", "demo");
            navigate("/")
        }
        if (sessionStorage.getItem("demo")) {
            setDemo("demo")
        }
        if (lDealerId) {
            sessionStorage.removeItem("demo")
            setDemo("")
        }
    }, [pathname, lDealerId, navigate, setDemo]);
    // const origin = window.location.origin

    // ---------------------------Wished Items------------------------

    useEffect(() => {
        const localWished = JSON.parse(localStorage.getItem("wished"))
        if (localWished && wished.length === 0) {
            if (removeWished === 0) {
                localStorage.removeItem("wished")
            } else {
                setWished(localWished)
            }
        }
        if (wished.length !== 0) {
            localStorage.setItem("wished", JSON.stringify(wished))
        }

    }, [wished, setWished, removeWished,])

    return (
        <React.Fragment>
            <div className="position-relative cp mainWidth">
                {pathname === parms || pathname === aboutparms || pathname === jobId ? ''
                    : pathname === '/careers' ? <img src={"https://careers.swiggy.com/assets/img/banner3.jpg"} alt="header" className="w-100 header_bg_img" />
                        :
                        <Slider
                            className="mx-0"
                            autoplay={true}
                            speed={3000}
                            slidesToShow={1}
                            slidesToScroll={1}
                            arrows={false}
                            infinite={true}
                        >
                            {bannerData.length === 0 ?
                                homeBanner.map((item, index) =>
                                    <img key={index} src={item} alt="header" className="w-100 mob_header_bg_img" />
                                ) :
                                bannerData.map((item, index) =>
                                    <img key={index} src={process.env.REACT_APP_S3URL + item} alt="header" className="w-100 mob_header_bg_img" />
                                )}
                        </Slider>

                }
                {pathname !== aboutparms ? '' :

                    <div className="position-relative">
                        <img
                            src={process.env.REACT_APP_S3URL + basicInfo.storeImg}
                            alt={basicInfo.storeName}
                            className="LandingImg"
                        />
                        <div className="position-absolute aboutDealerText_16 border_Img bg-white text-center p-1">
                            {/* {!basicInfo.profileImage ?
                                basicInfo.firstName.charAt(0).toUpperCase()
                                : */}
                            <img
                                src={process.env.REACT_APP_S3URL + basicInfo.profileImage}
                                alt={basicInfo.firstName + ' ' + basicInfo.lastName}
                                className="img_HW"
                            />
                            {/* } */}
                            <div className=" aboutDealerText_20 cpm">{basicInfo.firstName + ' ' + basicInfo.lastName}</div>
                            <div className="cpm">{basicInfo.title}</div>
                            <div>at</div>
                            <div className=" turnWid2">{basicInfo.storeName}</div>
                        </div>
                    </div>

                }
                <div className={pathname === parms || pathname === jobId ? 'text-dark' : 'position-absolute text-white top-0 w-100'}>
                    <Row className="mx-1 mt-1">
                        <Col xs="2" className="px-0">
                            <Link to="/">
                                <img src={pathname === parms || pathname === jobId ? "/assets/images/wallicon_logo.png" : "/assets/images/wallicon_white_logo.png"} alt="wallicon" height="27" width="47" />
                            </Link>
                        </Col>
                        {demo ?
                            <Col xs="8" className="tw_center ls5 mt-1 px-0"  >
                                <h5 className="fs_16 pf ls13em headDemobr">YOUR COMPANY NAME</h5>
                            </Col> :
                            localStorage.getItem("dealerId") ?
                                <Col xs="8" className="tw_center ls5 mt-1 px-0"  >
                                    <div className="fs10 pf ls06em">Authorised Dealer</div>
                                    <h5 className="fs_16 pf ls13em headDemobr">{localStorage.getItem("storeName")}</h5>
                                </Col>
                                : <Col xs="8"></Col>
                        }
                        <Col xs="2" className="text-end px-0">
                            {/* <img src="/assets/icons/headerBag.svg" alt="bag" height="22" /> */}
                            <div className="mouse" onClick={() => navigate("/checkout/cart")}>
                                <img src={pathname === parms || pathname === jobId ? "/assets/icons/bag.svg" : "/assets/icons/bagWhite.svg"} alt="bg" height={22} className="mouse mt7 me-3" />

                                {cart.length === 0 ? "" : <>
                                    <img src={pathname === parms || pathname === jobId ? "/assets/icons/cartBlack.svg" : "/assets/icons/cartWhite.svg"} alt="cart" className="cartIcon" />
                                    <label className="cartLength">{cart.length}</label>
                                </>
                                }
                            </div>
                        </Col>
                    </Row>
                </div>
                
            </div>

        </React.Fragment>
    )
}

export default MobHeader


